const pageNameKey = "otaConfigurationsDrawerModal";

export const otaConfigurationsDrawerModalEn = {
  [pageNameKey]: {
    releaseNewConfigurationText: "Release New Configuration",
    releaseConfigurationDetailsText: "Configuration Details",
    releaseConfigurationText: "Release",
    cancelText: "Cancel",
    fixValidateFieldText: "Please fix following fields: ",
    uploadFailedText: "Something went wrong while uploading configuration.",
  },
};

export const otaConfigurationsDrawerModalPtBr = {
  [pageNameKey]: {
    releaseNewConfigurationText: "Lançar nova configuração",
    releaseConfigurationDetailsText: "Detalhes da configuração",
    releaseConfigurationText: "Versão",
    cancelText: "Cancelar",
    fixValidateFieldText: "Por favor, corrija os seguintes campos: ",
    uploadFailedText: "Algo deu errado ao enviar a configuração.",
  },
};

export const otaConfigurationsDrawerModalDe = {
  [pageNameKey]: {
    releaseNewConfigurationText: "Neue Konfiguration freigeben",
    releaseConfigurationDetailsText: "Konfigurationsdetails",
    releaseConfigurationText: "Freigeben",
    cancelText: "Stornieren",
    fixValidateFieldText: "Bitte korrigieren Sie die folgenden Felder:",
    uploadFailedText:
      "Beim Hochladen der Konfiguration ist ein Fehler aufgetreten.",
  },
};

export const otaConfigurationsDrawerModalZhHans = {
  [pageNameKey]: {
    releaseNewConfigurationText: "发布新配置",
    releaseConfigurationDetailsText: "配置详情",
    releaseConfigurationText: "发布",
    cancelText: "取消",
    fixValidateFieldText: "请更正以下字段：",
    uploadFailedText: "上传配置时出错。",
  },
};

export const otaConfigurationsDrawerModalIt = {
  [pageNameKey]: {
    releaseNewConfigurationText: "Crea nuova configurazione",
    releaseConfigurationDetailsText: "Dettagli di configurazione",
    releaseConfigurationText: "Crea",
    cancelText: "Annulla",
    fixValidateFieldText: "Correggi i seguenti campi: ",
    uploadFailedText:
      "Qualcosa è andato storto durante il caricamento della configurazione.",
  },
};

export const otaConfigurationsDrawerModalEs = {
  [pageNameKey]: {
    releaseNewConfigurationText: "Publicar nueva configuración",
    releaseConfigurationDetailsText: "Detalles de la configuración",
    releaseConfigurationText: "Lanzar",
    cancelText: "Cancelar",
    fixValidateFieldText: "Por favor, corrige los siguientes campos: ",
    uploadFailedText: "Se produjo un error al cargar la configuración.",
  },
};

export const otaConfigurationsDrawerModalNl = {
  [pageNameKey]: {
    cancelText: "Annuleren",
    fixValidateFieldText: "Corrigeer de volgende velden: ",
    releaseConfigurationDetailsText: "Configuratiedetails",
    releaseConfigurationText: "Uitgeven",
    releaseNewConfigurationText: "Nieuwe configuratie uitgeven",
    uploadFailedText:
      "Er is iets misgegaan bij het uploaden van de configuratie.",
  },
};

export const otaConfigurationsDrawerModalTr = {
  [pageNameKey]: {
    cancelText: "İptal etmek",
    fixValidateFieldText: "Lütfen aşağıdaki alanları düzeltin:",
    releaseConfigurationDetailsText: "Yapılandırma Ayrıntıları",
    releaseConfigurationText: "Serbest bırakmak",
    releaseNewConfigurationText: "Yeni Yapılandırmayı Yayınla",
    uploadFailedText: "Yapılandırma yüklenirken bir şeyler ters gitti.",
  },
};
